import {
  SlBadge
} from "./chunk.L4XPMVVI.js";

// src/components/badge/badge.ts
var badge_default = SlBadge;
SlBadge.define("sl-badge");

export {
  badge_default
};
